export enum SwapType {
  Cancel = 1,
  Teacher = 2,
  Subject = 3
}
